import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { IndexPageComponent } from './pages/index-page/index-page.component';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { ForgotPasswordPageComponent } from './pages/forgot-password-page/forgot-password-page.component';
import { AboutPageComponent } from './pages/about-page/about-page.component';
import { ShopsPageComponent } from './pages/shops-page/shops-page.component';
import { ShopPageComponent } from './pages/shop-page/shop-page.component';
import { PageSeo } from './services/seo.service';

/**
 * Route metadata, in Bulgarian because the site's default language is Bulgarian
 * (see AppComponent.setDefaultLang) and its first market is Bulgarian shops.
 */
export interface SeoRouteData {
   seo: PageSeo;
}

/**
 * Pages of the consumer price watch Oopsy used to be (archive/watch-era-final)
 * and of search before it. Hosting answers a direct load with a 301 to /; these
 * cover a link followed inside the app.
 */
const RETIRED_PATHS = ['search/:slug', 'offer', 'history', 'watchlist', 'bought', 'lists', 'w/:publicId', 'how-it-works'];

export const routes: Routes = [
   {
      path: '',
      component: IndexPageComponent,
      data: {
         seo: {
            title: 'Упси! — умно търсене за вашия онлайн магазин',
            description: 'Търсачка за онлайн магазини, която разбира и латиница, и правописни грешки. ' +
               'Вижте я върху своя магазин за минута, сложете я с един ред код.',
            path: '/',
         },
      } satisfies SeoRouteData,
   },
   {
      path: 'business',
      component: ShopsPageComponent,
      data: {
         seo: {
            title: 'Моите магазини — Упси!',
            description: 'Магазините, в които търсенето е на Упси!.',
            path: '/business',
            noindex: true,
         },
      } satisfies SeoRouteData,
   },
   {
      path: 'business/:shopId',
      component: ShopPageComponent,
      data: {
         seo: {
            title: 'Магазин — Упси!',
            description: 'Инсталиране и статистика на търсенето.',
            noindex: true,
         },
      } satisfies SeoRouteData,
   },
   {
      path: 'about',
      component: AboutPageComponent,
      data: {
         seo: {
            title: 'Политика за поверителност — Упси!',
            description: 'Как Упси! събира, използва и защитава вашите лични данни.',
            path: '/about',
         },
      } satisfies SeoRouteData,
   },
   {
      path: 'login',
      component: LoginPageComponent,
      data: {
         seo: {
            title: 'Вход — Упси!',
            description: 'Влезте в профила си, за да управлявате търсенето в магазина си.',
            path: '/login',
            noindex: true,
         },
      } satisfies SeoRouteData,
   },
   {
      path: 'forgot-password',
      component: ForgotPasswordPageComponent,
      data: {
         seo: {
            title: 'Забравена парола — Упси!',
            description: 'Възстановяване на достъпа до профила.',
            path: '/forgot-password',
            noindex: true,
         },
      } satisfies SeoRouteData,
   },
   ...RETIRED_PATHS.map((path) => ({ path, redirectTo: '' })),
];

@NgModule({
   imports: [
      RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' }),
   ],
   exports: [RouterModule],
})
export class AppRoutingModule { }
